import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-light-green text-black p-4 mt-8 dark:bg-gray-800 dark:text-white">
      <div className="container mx-auto text-center flex flex-col items-center space-y-2">
        {/* Logo */}
        <img
          src="/logo.png"
          alt="Ekul Consulting Logo"
          className="w-10 h-10 rounded-full mb-2"
        />

        {/* Copyright Text */}
        <p>&copy; 2025 Ekul Consulting Agency Limited. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;